export default __webpack_public_path__ + "364d83ab92197f9616aa488d5cafd49d.png";